// Libs
import React from 'react'

// CSS
import "./styles.scss"

const Label = ({ gutter, gutterTop, gutterBottom, children, ...props }) => {
  const labelStyle = {
    margin: `${gutter / 2}px 0px`,
    marginTop: `${gutterTop}px`,
    marginBottom: `${gutterBottom}px`
  }

  return (
    <div style={labelStyle} className="label" {...props}>
      <h4 className="label__title">{children}</h4>
      <span className="label__line" />
    </div>
  )
}

export default Label
